import { debounce } from "../../plugins/debounce";

// export const setOfferTableButtonsAsSticky = debounce(() => {
export const setOfferTableButtonsAsSticky = () => {
	const offerTables = $(".offer-table");
	if (offerTables) {
		// let timeout;
		// clearTimeout(timeout);
		// timeout = setTimeout(function () {

		// console.log('setOfferTableButtonsAsSticky');
		offerTables.each(function () {
			const that = $(this);
			const floatingButtons = that.find(".offer-table-buttons-row");
			const elementPosition = that.offset().top;
			const elementHeight = that.outerHeight();
			const windowPosition = $(window).scrollTop();
			const windowHeight = $(window).height();
			const headerRowHeight = that.find(".offers-header-row").outerHeight();
			const priceRowHeight = that.find(".offers-header-row + *").outerHeight();
			const displayShiftRatio = headerRowHeight + priceRowHeight + 50;
			const buttonsHeight = that.find(".offer-table-buttons-row").outerHeight();

			if (
				windowPosition + windowHeight > elementPosition + displayShiftRatio &&
				windowPosition + windowHeight <
					elementPosition + elementHeight - buttonsHeight / 2
			) {
				if (!floatingButtons.hasClass("fixed")) {
					floatingButtons.addClass("fixed");
					floatingButtons.removeClass("no-fixed");
					return;
				}
			}

			if (windowPosition + windowHeight < elementPosition + displayShiftRatio) {
				if (floatingButtons.hasClass("fixed")) {
					floatingButtons.removeClass("fixed");
					floatingButtons.addClass("no-fixed");
					return;
				}
			}

			if (
				windowPosition + windowHeight >
				elementPosition + elementHeight - buttonsHeight / 2
			) {
				if (floatingButtons.hasClass("fixed")) {
					floatingButtons.removeClass("fixed");
					floatingButtons.addClass("no-fixed");
					return;
				}
			}
		});
		// }, 3000);
	}
};
//   }, 250);
